import {
  dateFormatterDayMonthYear,
  dateFormatterHourMinute,
  Spacer,
  TableTagElectricChargeType,
  TextCapitalized,
} from "@qivia/ui";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ElectricCharge } from "../electricChargingAPI";
import "../../../../i18n/i18n";

const formatHour = (date: string) =>
  dateFormatterHourMinute(new Date(date)).replace(":", "h");

export const SidePanelHeader = (props: { charge: ElectricCharge }) => {
  const { t } = useTranslation();
  const { charge } = props;
  const chargeDay = charge.startAt ?? charge.stopAt;

  return (
    <StyledPanelContainer>
      <StyledTitle>
        <TextCapitalized>
          {t("electric_charging.sidePanel.title")}
        </TextCapitalized>
      </StyledTitle>
      <Spacer y={1} />
      {charge.type && (
        <TableTagElectricChargeType
          type={t(`electric_charging.type.${charge.type}`)}
        />
      )}
      <Spacer y={1.5} />
      <StyledRowAmount>
        <StyledAmount>
          {charge.totalCost !== null ? charge.totalCost.toFixed(2) : "-"}
        </StyledAmount>
        <StyledCurrency>&nbsp;EUR</StyledCurrency>
      </StyledRowAmount>
      <Spacer y={1} />
      <StyledBodyM>{charge.locationCity}</StyledBodyM>
      <Spacer y={0.25} />
      {chargeDay && (
        <StyledDate>
          <div>{dateFormatterDayMonthYear(new Date(chargeDay))}</div>
          <div>
            {charge.startAt && formatHour(charge.startAt)}
            {charge.startAt && charge.stopAt && " - "}
            {charge.stopAt && formatHour(charge.stopAt)}
          </div>
        </StyledDate>
      )}
    </StyledPanelContainer>
  );
};

const StyledPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const StyledTitle = styled.div`
  ${typographies["Header/H3"]};
  color: ${colors["colors/text/black"]};
`;

const StyledRowAmount = styled.div`
  display: flex;
  align-items: flex-end;
`;

const StyledAmount = styled.div`
  font-size: 2.25rem;
  font-weight: 400;
`;

const StyledCurrency = styled.div`
  font-size: 1rem;
  font-weight: 400;
`;

const StyledBodyM = styled.div`
  ${typographies["Body/M"]};
`;

const StyledDate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${typographies["Body/XXS"]};
  color: ${colors["colors/text/darkGrey"]};
`;
